module.exports = __webpack_public_path__ + "static/img/31-北京邮电大学附属小学(今典校区).e1914be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/31-北京邮电大学附属小学(今典校区).png
// module id = AZuG
// module chunks = 0